import { useState } from 'react';
import './UpdateTrademarkApplicationForm.css';
import { updateTrademarkApplication } from '../../utilities/api/trademarkApplications';



export default function UpdateTrademarkApplicationForm({user, trademarkApplication, updateApplication, toggleNotifications}) {
    const defaultState = {
        clientName: trademarkApplication.clientName||'',
        clientID: trademarkApplication.clientID||null,
        applicationType: trademarkApplication.applicationType||'',
        RPNumber: trademarkApplication.RPNumber||'',
        filingFirm: trademarkApplication.filingFirm||'',
        firmRefNumber: trademarkApplication.firmRefNumber||'',
        contact: trademarkApplication.contact||'',
        applicants: trademarkApplication.applicants||'',
        applicantAddress: trademarkApplication.applicantAddress||'',
        trademarkClasses: trademarkApplication.trademarkClasses||'',
        highlyRelevantTrademarkClass: trademarkApplication.highlyRelevantTrademarkClass||'',
        trademarkType: trademarkApplication.trademarkType||'',
        applicationNumber: trademarkApplication.applicationNumber||'',
        filing: trademarkApplication.filing||'',
        filingDate: trademarkApplication.filingDate||'',
        trademarkDescription: trademarkApplication.trademarkDescription||'',
        priorityDate: trademarkApplication.priorityDate||'',
        priorityApplication: trademarkApplication.priorityApplication||'',
        registrationNumber: trademarkApplication.registrationNumber||'',
        registrationDate: trademarkApplication.registrationDate||'',
        feesPaid: trademarkApplication.feesPaid||'',
        nationalEntryDate: trademarkApplication.nationalEntryDate||'',
        applicationStatus: trademarkApplication.applicationStatus||'',
        examinationByOffice: trademarkApplication.examinationByOffice||'',
        approvalOrDenial: trademarkApplication.approvalOrDenial||'',
        NOA: trademarkApplication.NOA||'',
        maintenanceOfRegistration: trademarkApplication.maintenanceOfRegistration||'',
        lastAction: trademarkApplication.lastAction||'',
        nextAction: trademarkApplication.nextAction||'',
        nextActionDueDate: trademarkApplication.nextActionDueDate||'',
        notes: trademarkApplication.notes||'',
        driveFolderLocation: trademarkApplication.driveFolderLocation||'',
        trademarkClassesForSearch: trademarkApplication.trademarkClassesForSearch||'',
        trademarkClassesForFiling: trademarkApplication.trademarkClassesForFiling||'',
    }
    const [formData, setFormData] = useState(defaultState)
    const rpNumberReg = /^([A-Z]{2}-[0-9]{4}\.[0-9]{2,}\.[0-9]{3}.*)$/
    const [isValidRPNumber, setIsValidRPNumber] = useState(true)
    const [isSubmitting, setIsSubmitting] = useState(false)

    const handleSubmit = async (evt) =>{
        evt.preventDefault();
        setIsSubmitting(true)
        try {
            const updatedTrademarkApplication = await updateTrademarkApplication(trademarkApplication._id, formData)
            updateApplication(updatedTrademarkApplication)
            await toggleNotifications('success', `Trademark Application "${trademarkApplication.applicationNumber}" Successfully Updated!`, '#FFFFFF')
        } catch (error) {
            console.log(error)
            await toggleNotifications('error', `Failed to Update Trademark Application "${trademarkApplication.applicationNumber}"!`, '#FFFFFF')
        }
        setIsSubmitting(false)
    }

    

    async function handleChange(evt) {
        const newFormData = {
          ...formData,
          [evt.target.name]: evt.target.value,
        }

        if (evt.target.name === 'RPNumber') {
            await checkRPNumber(evt)
        }

        setFormData(newFormData);
    }

    const checkRPNumber = async (evt) => {
        const rpNumber = evt.target.value
        rpNumberReg.test(rpNumber) ? setIsValidRPNumber(true) : setIsValidRPNumber(false)
    }


    const disabled = !formData.clientName || !formData.clientID || !formData.RPNumber || !isValidRPNumber || !formData.applicationNumber || !formData.filingDate
  return (
    <div className='UpdateTrademarkApplicationForm'>
        <form onSubmit={handleSubmit} id={`updateTrademarkApplicationForm-${trademarkApplication._id}`}>
            <div className='formContent'>
                <div className='form-group'>
                    <label htmlFor={`clientName${trademarkApplication._id}`} className='form-label'>Client Name <span className='requiredField'><strong>*</strong></span></label>
                    <input type="text" id={`clientName${trademarkApplication._id}`} name='clientName' className='form-control' defaultValue={formData.clientName} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`clientID${trademarkApplication._id}`} className='form-label'>Client ID <span className='requiredField'><strong>*</strong></span></label>
                    <input type="number" min={0} id={`clientID${trademarkApplication._id}`} name='clientID' className='form-control' defaultValue={formData.clientID} onChange={handleChange}/>
                </div>
                <div className='form-group rpNumber'>
                    <div className='input'>
                        <label htmlFor={`RPNumber${trademarkApplication._id}`} className='form-label'>RP Number <span className='requiredField'><strong>*</strong></span></label>
                        <input type="text" id={`RPNumber${trademarkApplication._id}`} name='RPNumber' className='form-control' defaultValue={formData.RPNumber} onChange={handleChange}/>
                    </div>
                    <div className='rpNumberStatus'>
                        <small className="form-text checkIsValidRPNumber" style={{backgroundColor:`${isValidRPNumber? 'green' : 'red'}`, color:'white'}}>Format: XX-0000.00.000</small>
                    </div>
                </div>
                <div className='form-group'>
                    <label htmlFor={`applicationType${trademarkApplication._id}`} className='form-label'>Application Type</label>
                    <select id={`applicationType${trademarkApplication._id}`} name='applicationType' className='form-select' defaultValue={formData.applicationType} onChange={handleChange}>
                        <option value="">---Select Application Type---</option>
                        <option value="US">US</option>
                        <option value="canadian">Canadian</option>
                        <option value="other">Other</option>
                    </select>
                </div>
                <div className='form-group'>
                    <label htmlFor={`filingFirm${trademarkApplication._id}`} className='form-label'>Filing Firm</label>
                    <input type="text" id={`filingFirm${trademarkApplication._id}`} name='filingFirm' className='form-control' defaultValue={formData.filingFirm} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`firmRefNumber${trademarkApplication._id}`} className='form-label'>Firm Ref Number</label>
                    <input type="text" id={`firmRefNumber${trademarkApplication._id}`} name='firmRefNumber' className='form-control' defaultValue={formData.firmRefNumber} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`contact${trademarkApplication._id}`} className='form-label'>Contact</label>
                    <input type="text" id={`contact${trademarkApplication._id}`} name='contact' className='form-control' defaultValue={formData.contact} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`applicants${trademarkApplication._id}`} className='form-label'>Applicants</label>
                    <input type="text" id={`applicants${trademarkApplication._id}`} name='applicants' className='form-control' defaultValue={formData.applicants} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`applicantAddress${trademarkApplication._id}`} className='form-label'>Applicant Address</label>
                    <input type="text" id={`applicantAddress${trademarkApplication._id}`} name='applicantAddress' className='form-control' defaultValue={formData.applicantAddress} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`trademarkClasses${trademarkApplication._id}`} className='form-label'>Trademark Classes</label>
                    <input type="text" id={`trademarkClasses${trademarkApplication._id}`} name='trademarkClasses' className='form-control' defaultValue={formData.trademarkClasses} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`highlyRelevantTrademarkClass${trademarkApplication._id}`} className='form-label'>Highly Relevant Trademark Class</label>
                    <input type="text" id={`highlyRelevantTrademarkClass${trademarkApplication._id}`} name='highlyRelevantTrademarkClass' className='form-control' defaultValue={formData.highlyRelevantTrademarkClass} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`trademarkType${trademarkApplication._id}`} className='form-label'>Trademark Type</label>
                    <select id={`trademarkType${trademarkApplication._id}`} name='trademarkType' className='form-select' defaultValue={formData.trademarkType} onChange={handleChange}>
                        <option value="">---Select Trademark Type---</option>
                        <option value="word">Word</option>
                        <option value="image">Image</option>
                        <option value="design">Design</option>
                        <option value="composite">Composite</option>
                    </select>
                </div>
                <div className='form-group'>
                    <label htmlFor={`applicationNumber${trademarkApplication._id}`} className='form-label'>Application Number <span className='requiredField'><strong>*</strong></span></label>
                    <input type="text" id={`applicationNumber${trademarkApplication._id}`} name='applicationNumber' className='form-control' defaultValue={formData.applicationNumber} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`filing${trademarkApplication._id}`} className='form-label'>Trademark Type</label>
                    <select id={`filing${trademarkApplication._id}`} name='filing' className='form-select' defaultValue={formData.filing} onChange={handleChange}>
                        <option value="">---Select Filing Type---</option>
                        <option value="useInCommerce">Use in Commerce</option>
                        <option value="intentToUse">Intent to Use</option>
                        <option value="baseApplication">Base Application</option>
                        <option value="foreignPriority">Foreign Priority</option>
                        <option value="foreignRegistration">Foreign Registration</option>
                        <option value="internationalFiling">International Filing</option>
                    </select>
                </div>
                <div className='form-group'>
                    <label htmlFor={`trademarkDescription${trademarkApplication._id}`} className='form-label'>Trademark Description</label>
                    <textarea id={`trademarkDescription${trademarkApplication._id}`} name='trademarkDescription' className='form-control' defaultValue={formData.trademarkDescription} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`priorityDate${trademarkApplication._id}`} className='form-label'>Priority Date</label>
                    <input type="date" id={`priorityDate${trademarkApplication._id}`} name='priorityDate' className='form-control' defaultValue={formData.priorityDate.split('T')[0]} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`priorityApplication${trademarkApplication._id}`} className='form-label'>Priority Application</label>
                    <input type="text" id={`priorityApplication${trademarkApplication._id}`} name='priorityApplication' className='form-control' defaultValue={formData.priorityApplication} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`filingDate${trademarkApplication._id}`} className='form-label'>Filing Date <span className='requiredField'><strong>*</strong></span></label>
                    <input type="date" id={`filingDate${trademarkApplication._id}`} name='filingDate' className='form-control' defaultValue={formData.filingDate.split('T')[0]} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`registrationNumber${trademarkApplication._id}`} className='form-label'>Registration Number</label>
                    <input type="text" id={`registrationNumber${trademarkApplication._id}`} name='registrationNumber' className='form-control' defaultValue={formData.registrationNumber} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`registrationDate${trademarkApplication._id}`} className='form-label'>Registration Date</label>
                    <input type="date" id={`registrationDate${trademarkApplication._id}`} name='registrationDate' className='form-control' defaultValue={formData.registrationDate.split('T')[0]} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`feesPaid${trademarkApplication._id}`} className='form-label'>Fees Paid</label>
                    <select id={`feesPaid${trademarkApplication._id}`} name='feesPaid' className='form-select' defaultValue={formData.feesPaid} onChange={handleChange}>
                        <option value="">---Select Option---</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                    </select>
                </div>
                <div className='form-group'>
                    <label htmlFor={`nationalEntryDate${trademarkApplication._id}`} className='form-label'>National Entry Date</label>
                    <input type="date" id={`nationalEntryDate${trademarkApplication._id}`} name='nationalEntryDate' className='form-control' defaultValue={formData.nationalEntryDate.split('T')[0]} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`applicationStatus${trademarkApplication._id}`} className='form-label'>Application Status</label>
                    <select id={`applicationStatus${trademarkApplication._id}`} name='applicationStatus' className='form-select' defaultValue={formData.applicationStatus} onChange={handleChange}>
                        <option value="">---Select Application Status---</option>
                        <option value="new">New</option>
                        <option value="officeActionIssued">Office Action Issued</option>
                        <option value="filed">Filed</option>
                        <option value="formalized">Formalized</option>
                        <option value="awaitingExam">Awaiting Exam</option>
                        <option value="examReportIssued">Exam Report Issued</option>
                        <option value="approved">Approved</option>
                        <option value="NOAIssued">NOA Issued</option>
                        <option value="advertised">Advertised</option>
                        <option value="registered">Registered</option>
                        <option value="opposed">Opposed</option>
                        <option value="abandoned">Abandoned</option>
                        <option value="allowed">Allowed</option>
                        <option value="cancelled">Cancelled</option>
                    </select>
                </div>
                <div className='form-group'>
                    <label htmlFor={`examinationByOffice${trademarkApplication._id}`} className='form-label'>Examination By Office</label>
                    <select id={`examinationByOffice${trademarkApplication._id}`} name='examinationByOffice' className='form-select' defaultValue={formData.examinationByOffice} onChange={handleChange}>
                        <option value="">---Select Option---</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                    </select>
                </div>
                <div className='form-group'>
                    <label htmlFor={`approvalOrDenial${trademarkApplication._id}`} className='form-label'>Approval or Denial</label>
                    <select id={`approvalOrDenial${trademarkApplication._id}`} name='approvalOrDenial' className='form-select' defaultValue={formData.approvalOrDenial} onChange={handleChange}>
                        <option value="">---Select Option---</option>
                        <option value="approved">Approved</option>
                        <option value="denied">Denied</option>
                    </select>
                </div>
                <div className='form-group'>
                    <label htmlFor={`NOA${trademarkApplication._id}`} className='form-label'>NOA</label>
                    <select id={`NOA${trademarkApplication._id}`} name='NOA' className='form-select' defaultValue={formData.NOA} onChange={handleChange}>
                        <option value="">---Select Option---</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                    </select>
                </div>
                <div className='form-group'>
                    <label htmlFor={`maintenanceOfRegistration${trademarkApplication._id}`} className='form-label'>Maintenance of Registration</label>
                    <select id={`maintenanceOfRegistration${trademarkApplication._id}`} name='maintenanceOfRegistration' className='form-select' defaultValue={formData.maintenanceOfRegistration} onChange={handleChange}>
                        <option value="">---Select Option---</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                    </select>
                </div>
                <div className='form-group'>
                    <label htmlFor={`lastAction${trademarkApplication._id}`} className='form-label'>Last Action</label>
                    <input type="text" id={`lastAction${trademarkApplication._id}`} name='lastAction' className='form-control' defaultValue={formData.lastAction} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`nextAction${trademarkApplication._id}`} className='form-label'>Next Action</label>
                    <input type="text" id={`nextAction${trademarkApplication._id}`} name='nextAction' className='form-control' defaultValue={formData.nextAction} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`nextActionDueDate${trademarkApplication._id}`} className='form-label'>Next Action Due Date</label>
                    <input type="date" id={`nextActionDueDate${trademarkApplication._id}`} name='nextActionDueDate' className='form-control' defaultValue={formData.nextActionDueDate.split('T')[0]} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`notes${trademarkApplication._id}`} className='form-label'>Notes</label>
                    <textarea id={`notes${trademarkApplication._id}`} name='notes' className='form-control' defaultValue={formData.notes} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`driveFolderLocation${trademarkApplication._id}`} className='form-label'>Folder Location</label>
                    <input type="text" id={`driveFolderLocation${trademarkApplication._id}`} name='driveFolderLocation' className='form-control' defaultValue={formData.driveFolderLocation} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`trademarkClassesForSearch${trademarkApplication._id}`} className='form-label'>Trademark Classes For Search</label>
                    <input type="text" id={`trademarkClassesForSearch${trademarkApplication._id}`} name='trademarkClassesForSearch' className='form-control' defaultValue={formData.trademarkClassesForSearch} onChange={handleChange}/>
                </div>
                <div className='form-group'>
                    <label htmlFor={`trademarkClassesForFiling${trademarkApplication._id}`} className='form-label'>Trademark Classes For Filing</label>
                    <input type="text" id={`trademarkClassesForFiling${trademarkApplication._id}`} name='trademarkClassesForFiling' className='form-control' defaultValue={formData.trademarkClassesForFiling} onChange={handleChange}/>
                </div>
            </div>
        </form>
        <div className='formButtonContainer'>
            <button data-bs-dismiss="modal" className='cancel'>
                Cancel
            </button>
            <button data-bs-dismiss="modal" className="submit" type="submit" form={`updateTrademarkApplicationForm-${trademarkApplication._id}`} disabled={disabled||isSubmitting}>
                Update Application
            </button>
        </div>
    </div>
  )
}
